import { render } from "./newsletterTeaser.vue?vue&type=template&id=61210156"
import script from "./newsletterTeaser.vue?vue&type=script&lang=js"
export * from "./newsletterTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__